'use client';
import { ArtistCultureDisplayer } from 'components/collection/artist-culture-displayer';
import {
	lofiArtworkObjectModel,
	type LofiArtworkObjectModelInput,
} from 'helpers/collection';
import { type MouseEvent } from 'react';
import styles from './collection-object.module.scss';
import BaseCollectionObject, {
	type IProps as BaseCollectionObjectProps,
} from 'components/collection/base-collection-object';
import SafeHtml from 'components/safe-html';
import { type IDebuggingInfo } from 'components/collection/base-collection-object/debugging-info';
import type { GTMLinkAnalyticsProps } from 'components/controls/links/GTMLink';

const CollectionObject = (props: IProps) => {
	const { object, analytics, transparentBackground = false } = props;
	const formattedObject = lofiArtworkObjectModel(object);

	return (
		<BaseCollectionObject
			{...props}
			url={formattedObject.url}
			analytics={analytics}
			transparentBackground={transparentBackground}
			body={
				<>
					<div className={styles.culture}>
						<ArtistCultureDisplayer object={formattedObject} />
					</div>
					<div>
						<SafeHtml>{formattedObject.date}</SafeHtml>
					</div>
				</>
			}
		/>
	);
};

export interface IProps
	extends IDebuggingInfo, Omit<BaseCollectionObjectProps, 'url'> {
	analytics?: GTMLinkAnalyticsProps;
	enforceMaxWidth?: boolean;
	handleObjectClick?: (e: MouseEvent, index?: number) => void;
	index?: number;
	isLoading?: boolean;
	object: LofiArtworkObjectModelInput;
	lazyLoad?: boolean;
	/** @remarks this card isn't always used in a search context, so its nice to show/hide this, even in dev */
	showSearchDebug?: boolean;
	transparentBackground?: boolean;
}

export default CollectionObject;
